export default __webpack_public_path__ + "static/media/footer-linkedin.b4476283.svg";